<mat-icon
    [matTooltip]="tooltip"
    [ngClass]="iconClass"
    [svgIcon]="iconName">
</mat-icon>
